import { z } from 'zod';
export const PlanInput = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    monthlyPriceCents: z.number().int().nonnegative(),
    maxConcurrentUsers: z.number().int().positive(),
    maxKnowledgeMb: z.number().int().positive(),
    /**
     * Maximum number of human agents the owner of this plan can register.
     * 0 disables the human-handoff feature entirely.
     */
    maxAgents: z.number().int().nonnegative().default(0),
    includedTokens: z.number().int().nonnegative(),
    features: z.record(z.string(), z.unknown()).optional(),
    archived: z.boolean().optional(),
});
export const PlanDTO = PlanInput.extend({
    id: z.string().uuid(),
    stripeProductId: z.string().nullable(),
    stripePriceId: z.string().nullable(),
    archived: z.boolean(),
    createdAt: z.string(),
});
export const SubscriptionStatus = z.enum([
    'incomplete',
    'incomplete_expired',
    'trialing',
    'active',
    'past_due',
    'canceled',
    'unpaid',
]);
/**
 * A subscription is "serviceable" (Bruno is live, widget shown) only while
 * billing is in good standing: `active` or `trialing`. Every other status
 * (`incomplete`, `past_due`, `unpaid`, `canceled`, `incomplete_expired`) means
 * the plan is inactive. Shared by the dashboard UI and mirrored by the API gate
 * so the front-end and back-end can't disagree about what counts as active.
 */
export function isServiceableSubscriptionStatus(status) {
    return status === 'active' || status === 'trialing';
}
export const SubscriptionDTO = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    websiteId: z.string().uuid(),
    planId: z.string().uuid(),
    stripeSubscriptionId: z.string().nullable(),
    status: SubscriptionStatus,
    currentPeriodEnd: z.string().nullable(),
    cancelAtPeriodEnd: z.boolean(),
    createdAt: z.string(),
});
export const CheckoutSessionInput = z.object({
    websiteId: z.string().uuid(),
    planId: z.string().uuid(),
});
export const TopUpInput = z.object({
    amountCents: z.number().int().min(500).max(100000),
});
export const BalanceDTO = z.object({
    balanceCents: z.number().int(),
});
//# sourceMappingURL=billing.js.map